<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<section>
	<div class="error-container">
		<span class="icon-unlink"></span>

		<span class="title">Oops! There was an error!</span>

		<span class="message">
			This error indicates that the requested page could not be loaded successfully. Below are
			some possible reasons for this occurrence, along with suggestions to resolve the
			problem.
		</span>

		<ul>
			<li>
				This page might be temporarily unavailable due to server maintenance or updates.
			</li>

			<li>
				There could be connectivity issues, such as a slow or unstable internet connection.
			</li>

			<li>The page's URL might be incorrect, or the content could have been removed.</li>

			<li>
				Access to the page might be restricted due to regional limitations or permissions.
			</li>
		</ul>

		<globalictcc-button
			label="Try again"
			(handleClick)="onRetry()"
		/>
	</div>
</section>
